<template>
  <div>
  </div>
</template>
<script>
import PaginationService from '@/services/paginationservice'
import * as code from '@/common/code'
import Util from '@/common/utility'
import msg from '@/common/msg'
import { applyFilters } from '@/common/filterLogic'

export default {
  data () {
    return {
      data: [],
      allData: [],
      originalData: [],
      extraData: null,
      loader: null,
      keepSort: false,
      isDestroy: false,
      lastEndIndex: 0,
      allParents: {},
      allParentAsins: [],
      filterAllDataCount: 0,
      isLoading: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    maxRows: {
      type: Number,
      default: 50
    },
    currentPage: {
      type: Number,
      default: 1
    },
    keyword: {
      type: String,
      default: ''
    },
    isShowPromotionProduct: {
      type: Boolean,
      default: false
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    },
    isHideNoItem: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default () {
        return {}
      }
    },
    isBasicPlan: {
      type: Boolean,
      default: false
    },
    selectedSort: {
      type: String,
      default: ''
    }
  },
  created () {
    this.fetchDataByAPI()
  },
  methods: {
    /*
     * Reload table
     *
     * @return void
     */
    reload () {
      this.fetchDataByAPI()
    },

    fetchDataByAPI () {
      if (this.isDestroy) return
      this.loader = this.$loading.show({
        container: this.$parent.$refs.table ? this.$parent.$refs.table : null
      })
      let url = this.url
      const apiMethod = PaginationService.getData
      apiMethod(url, null)
        .then((response) => {
          this.allData = response.data.products
          this.originalData = JSON.parse(JSON.stringify(this.allData))
          this.allParents = response.data.parents || {}
          this.allParentAsins = Object.keys(this.allParents)

          if (this.needExtraData) {
            this.extraData = {
              coefficient: response.coefficient
            }
          }

          this.$events.fire('noAmazon', true)
          this.$events.fire('apiSuccess', this.url)

          // Wait for the table to actually finish rendering before hiding the loader (see .finally below).
          return this.fetchDataClientMode()
        })
        .catch((err) => {
          if (err === code.amazonInfoNotFound) {
            this.$events.fire('noAmazon', false)
          } else if (err === code.amazonThrottleError) {
            this.$events.fire('amazonThrottleError', true)
            this.$emit('zIndex', 1040)
            this.$store.commit('toggleModal', {
              show: true,
              message: msg.amazonThrottleError
            })
          } else {
            this.$emit('zIndex', 1040)
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          }
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.$events.fire('done', this.url)
        })
    },
    fetchedDataLoading (type, reloadImageAsins, isShowLoading = false) {
      if (isShowLoading && !this.isLoading) {
        this.isLoading = true
        this.loader = this.$loading.show()
      }

      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          let allData = [...this.allData]
          if (this.selectedSort) {
            const [field, order] = this.selectedSort.split('_')
            const getValue = (item, field) => {
              switch (field) {
                case 'parentAsin': return item.parentAsin || ''
                case 'asin': return item.asin || ''
                case 'amazonPrice': return Number(item.amazonPrice || 0)
                case 'numberOfStock': return Number(item.numberOfStock || 0)
                case 'scInventoryQuantity': return Number(item.scInventoryQuantity || 0)
                default: return ''
              }
            }
            allData.sort((a, b) => {
              let valA = getValue(a, field)
              let valB = getValue(b, field)

              if (typeof valA === 'string') {
                const result = valA.localeCompare(valB, 'ja')
                return order === 'asc' ? result : -result
              }

              return order === 'asc' ? valA - valB : valB - valA
            })
          }
          const availableType = ['deleteAll', 'delete', 'expandParentRecord']
          const {
            judgmentStatus = [],
            amountReceived,
            stockStatus = [],
            warehouse = [],
            adStatus = [],
            pickupStatus = [],
            videoStatus = []
          } = this.filters
          const hasFilter =
            judgmentStatus.length > 0 ||
            stockStatus.length > 0 ||
            warehouse.length > 0 ||
            !!amountReceived ||
            adStatus.length > 0 ||
            (!this.isBasicPlan && pickupStatus.length > 0) ||
            videoStatus.length > 0 ||
            (this.keyword && this.keyword.trim().length > 0)

          let currentPage = this.currentPage
          let startPage = currentPage - 1

          allData = applyFilters(allData, this.filters, this.keyword, this.isBasicPlan).filter((item) => {
            if (this.isHideNoItem && (item.numberOfStock === '0' || item.numberOfStock === 0)) return false
            if (this.isShowPromotionProduct && item.hasOffer) return false
            return true
          })

          if (hasFilter) {
            this.filterAllDataCount = allData.length
            const totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
            if (totalPage > 0 && this.currentPage > totalPage) {
              currentPage = 1
              startPage = 0
              this.$emit('updateCurrentPage', currentPage)
            }
            this.data = allData.slice(startPage * this.maxRows, currentPage * this.maxRows)
          } else {
            this.filterAllDataCount = allData.length
            const totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
            if (totalPage > 0 && this.currentPage > totalPage) {
              currentPage = 1
              startPage = 0
              this.$emit('updateCurrentPage', currentPage)
            }
            allData = allData.slice(startPage * this.maxRows, currentPage * this.maxRows)
            this.data = [...allData]
            allData.length = 0
          }

          if (availableType.includes(type)) {
            if (reloadImageAsins.length && type === 'expandParentRecord') {
              let allObjectParentAsins = {}
              this.allParentAsins.forEach(parentAsin => {
                allObjectParentAsins[parentAsin] = parentAsin
              })
              let asinList = reloadImageAsins.filter(asin => !allObjectParentAsins[asin])
              this.fetchDataByExtraUrl(this.extraUrl, asinList)
            }
          }

          if (this.extraUrlMode) {
            setTimeout(() => {
              const asinList = this.data.map(item => item.asin)
              this.fetchDataByExtraUrl(this.extraUrl, asinList)
            }, 1000)
          }

          // Wait for Vue to actually patch the DOM (up to 1000 rows) before hiding the loader,
          // instead of a guessed timeout that can fire before the table finishes rendering.
          await this.$nextTick()
          if (isShowLoading) {
            this.isLoading = false
            this.loader && this.loader.hide()
          }
          resolve('success')
        }, 200)
      })
    },
    /*
     * Fetch data in client side
     *
     * @param {Boolean} showFromStart Data start from page 1
     * @param {Boolean} rowChanged All data had changed number of recrords
     *
     * @return void
     */
    async fetchDataClientMode (type = '', reloadImageAsins = [], isShowLoading = false) {
      let result = await this.fetchedDataLoading(type, reloadImageAsins, isShowLoading)
      if (result === 'success') {
        this.$emit('fetchedDataLoading')
      }
    },

    /*
     * Change data by parent component
     *
     * @param {Object} item Item need to be changed
     * @param {String} type Type of change
     *
     * @return void
     */
    handleData (item, type) {
      if (type === 'delete') {
        this.allData = this.allData.filter(data => data.asin !== item.asin)
        this.originalData = this.originalData.filter(data => data.asin !== item.asin)
        let itemParentAsin = item.parentAsin
        if (itemParentAsin) {
          let allParentAsins = [...new Set(this.allData.filter(item => item.parentAsin).map(item => item.parentAsin))]
          if (!allParentAsins.includes(itemParentAsin)) {
            this.allData = this.allData.filter(data => data.asin !== itemParentAsin)
            this.originalData = this.originalData.filter(data => data.asin !== itemParentAsin)
          }
        }
      } else if (type === 'update') {
        this.allData = this.allData.map((data) => {
          if (data.asin === item.asin && item.judgment) {
            data.judgmentStatus = item.judgment.judgmentStatusName
            data.judgmentStatusCode = item.judgment.judgmentCode
          }
          return data
        })
      } else if (type === 'deleteAll') {
        this.allData = this.allData.filter(data => !item.includes(data.asin))
        this.originalData = this.originalData.filter(data => !item.includes(data.asin))
      }
      this.fetchDataClientMode(type, [], true)
    },

    handleFilter () {
      this.fetchDataClientMode('', [], true)
    },

    fetchDataByExtraUrl (urlList, asin) {
      if (urlList.length > 0) {
        urlList.forEach(async (url) => {
          const {chunkData, delayTime} = this.checkInvalidData(url, asin)
          if (chunkData.length > 0 && !this.isDestroy) {
            for (const item of chunkData) {
              const payload = {
                // record: asin
                record: item
              }
              PaginationService.postDataByExtraUrl(url, payload)
                .then((response) => {
                  let objectResponse = {}
                  response.data.forEach((responseItem) => {
                    objectResponse[responseItem.asin] = responseItem
                  })
                  this.allData = this.allData.map((item) => {
                    let newItem = objectResponse[item.asin]
                    if (url === 'Product/get-identifiers' && newItem !== undefined) {
                      newItem = {
                        ean: newItem.identifiers.length ? newItem.identifiers[0].identifier : ''
                      }
                    }
                    if (newItem) {
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })

                  this.data = this.data.map((item) => {
                    let newItem = objectResponse[item.asin]
                    if (url === 'Product/get-identifiers' && newItem !== undefined) {
                      newItem = {
                        ean: newItem.identifiers.length ? newItem.identifiers[0].identifier : ''
                      }
                    }
                    if (newItem) {
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })
                })
                .catch((err) => {
                  this.$emit('zIndex', 1040)
                  this.$store.commit('toggleModal', {
                    show: true,
                    message: err
                  })
                })
              await Util.delay(delayTime)
            }
          }
        })
      }
    },

    checkInvalidData (extraUrl, asin) {
      let keys = []
      let maxDataPerRequest = 50
      let delayTime = 500
      switch (extraUrl) {
        case 'Product/get-image-name':
          keys = ['image']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        case 'Product/get-stock-info':
          keys = ['numberOfStock']
          maxDataPerRequest = 50
          delayTime = 500
          break
        case 'Product/get-identifiers':
          keys = ['ean']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        default:
          break
      }
      let objectAsins = {}
      asin.forEach((asinItem) => {
        objectAsins[asinItem] = asinItem
      })
      const matchData = this.data.filter(item => {
        let match = false
        keys.forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(item, key) || (key === 'ean' && !item.ean)) {
            match = true
          }
        })
        return objectAsins[item.asin] && match
      }).map(item => item.asin)
      const chunkData = Util.chunkArray(matchData, maxDataPerRequest)
      return {
        chunkData,
        delayTime
      }
    },

    updateOriginalData (item) {
      this.originalData = this.originalData.map(orignalItem => {
        if (orignalItem.asin === item.asin) {
          return JSON.parse(JSON.stringify(item))
        }
        return orignalItem
      })
    },

    calculateOfferPrice (currentItem, newItem) {
      if (currentItem.offerPrice === 0) {
        return newItem.amazonPrice > 0 ? Math.round(newItem.amazonPrice * 0.9) : null
      }
      return currentItem.offerPrice
    }
  },

  watch: {
    data () {
      this.$emit('onChangePage', this.data, this.extraData, this.filterAllDataCount)
      if (this.keepSort) {
        this.keepSort = false
      }
    },
    allData (newVal) {
      this.$emit('allData', newVal)
    },
    originalData (newVal) {
      this.$emit('originalData', newVal)
    },
    maxRows () {
      const isShowLoading = true
      this.fetchDataClientMode('', [], isShowLoading)
    },
    currentPage () {
      const isShowLoading = true
      this.fetchDataClientMode('', [], isShowLoading)
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/GetData.vue